import React from 'react';
import { Select, Tooltip } from 'antd';
import { InfoCircleOutlined, SyncOutlined } from '@ant-design/icons';
import kpiStore from '@globalStore/kpiStore';
import { humanize } from '@utils';
import { SPI_LABEL } from '@components/top-widget-panel/spi-panel/widgets/constants';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { StyledSPITag } from '../styled';
import useSPI from '../hooks/useSPI';

function KPIDropdown({ tempKpi, setTempKpi }) {
  const kpiList = kpiStore((state) => state.kpiList);
  const kpiOption = kpiList.find((t) => t.kpiID === tempKpi);
  const hasValidSelection = kpiList.some((t) => t.kpiID === tempKpi);
  const { spiScore, spiColor, isFetching, timeLabel } = useSPI({ threshold: kpiOption });
  const handleChange = (value) => {
    setTempKpi(value);
  };
  const options = kpiList.map((t) => ({ label: t.kpiName, value: t.kpiID }));
  return (
    <div style={{ margin: '5px 0px' }}>
      <Select
        value={hasValidSelection ? tempKpi : undefined}
        placeholder={kpiList.length && !hasValidSelection ? 'Select KPI' : undefined}
        style={{ width: 200 }}
        options={options}
        onChange={handleChange}
        onMouseDown={(e) => e.preventDefault()}
      />
      <Tooltip
        title={`${SPI_LABEL[CURRENT_PRODUCT_MODE]} Score for All Traffic for the last 6 hours (${timeLabel})`}
      >
        <StyledSPITag
          icon={isFetching ? <SyncOutlined spin /> : null}
          color={isFetching ? 'processing' : spiColor}
        >
          {`${SPI_LABEL[CURRENT_PRODUCT_MODE]}: ${humanize(spiScore, '')}`}
          <InfoCircleOutlined style={{ marginLeft: 5 }} />
        </StyledSPITag>
      </Tooltip>
    </div>
  );
}

export default KPIDropdown;
